module.exports = __webpack_public_path__ + "img/job-search-app.675e88dd.jpg";